export const CLIENT_ONBOARDING_STEPS = {
                                            'new': 0,
                                            'NewClient': 0,
                                            'edit':0, 
                                            'Users':1,
                                            'add-users':1,
                                            'Integrations':2,
                                            'integrations':2
                                        }